// extracted by mini-css-extract-plugin
export default {"container":"GO-z"};